import React, { useMemo } from 'react';
import ContainerHeader from 'routes/Pages/components/ContainerHeader';
import GridContainer from '@jumbo/components/GridContainer';
import {
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  FormControlLabel,
  Checkbox,
  TextField,
  Card,
  CardContent,
  CardHeader,
  Typography,
} from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';

import ClickIdeasWidget from 'routes/Metrics/Classic/ClickIdeaWidget';
import useNotifications from './customHooks/useNotifications';
import useForm from './customHooks/useForm';

import CoustomAccordian from './components/CoustomAccordian';
import CustomInputField from './components/CustomInputField';

// Send Notification Hook
// import useNotifications from './customHooks/useNotifications';
import useSendNotification from './customHooks/useSendNotification'; // adjust path

import CustomSearchInputField from './components/CustomSearchInputField';
import ManageNotificationModal from 'routes/Pages/SiteContract/components/ManageNotificationModal';

const NotificationPage = props => {
  const {
    notificationPageData,
    openNotificationForm,
    setOpenNotificationForm,
    handleNotificationSubmit,
    openNotificationType,
  } = useNotifications();

  const {
    siteAssessments,
    selectedSite,
    setSelectedSite,
    emailList,
    smsList,
    checkedEmails,
    checkedSMS,
    emailInput,
    smsInput,
    inAppInput,
    webAppInput,
    emailError,
    smsError,
    handleEmailInput,
    handleSMSInput,
    handleInAppInput,
    handleWebappInput,
    addEmail,
    addSMS,
    handleEmailCheck,
    handleSMSCheck,
    resetForm,
    allUsers,
    inAppUsers,
    webAppUsers,
    checkedInAppUsers,
    checkedWebAppUsers,
    addInAppUser,
    addWebAppUser,
    handleInAppCheck,
    handleWebAppCheck,
    whNumberList,
    selectedWH,
    setSelectedWH,
  } = useForm();

  // const { handleNotificationSubmit } = useNotifications();
  const { sendNotificationData, shortMessage, setShortMessage, handleAddMessage } = useSendNotification();

  const handleNotificationSubmitButton = async () => {
    await sendNotificationData(checkedEmails, checkedSMS);
    resetForm();
    setOpenNotificationForm(false);
  };
  // console.log(selectedSite);

  const handleClose = () => {
    setOpenNotificationForm(false);
    resetForm();
  };

  const handleSubmit = () => {
    handleNotificationSubmit();
    resetForm();
  };

  return (
    <div className="app-wrapper">
      <ContainerHeader match={props.match} title={'Notifications'} />
      <GridContainer>
        <Grid item xs={12} md={12} xl={12}>
          <GridContainer>
            {notificationPageData.map((item, index) => (
              <Grid item xs={12} sm={4} key={index}>
                <ClickIdeasWidget
                  number={item.cardValue ? item.CardValue : null}
                  subTitle={item.cardTitle}
                  backgroundColor={item.backgroundColor}
                  icon={item.icon}
                  clicklinkOnArrow={item.onClick}
                />
              </Grid>
            ))}
          </GridContainer>
        </Grid>
      </GridContainer>

      {openNotificationType === 'contract' ? (
        <ManageNotificationModal
          open={openNotificationForm}
          onClose={handleClose}
          mode="dropdown"
          whOptions={whNumberList}
        />
      ) : (
        <Dialog
          open={openNotificationForm}
          onClose={handleClose}
          fullWidth
          maxWidth={'xl'}
          PaperProps={{
            sx: {
              height: '90vh',
              display: 'flex',
              flexDirection: 'column',
              flex: 1,
            },
          }}>
          <DialogTitle sx={{ fontSize: '1.2rem', fontWeight: 700, pb: 0, pl: 3, borderBottom: '1px solid #e0e0e0' }}>
            Send Site Assessment Notification
          </DialogTitle>

          <DialogContent sx={{ flex: 1, overflowY: 'auto' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              <Box sx={{ mb: 0, mt: 3, display: 'flex', flexDirection: 'row', gap: '1rem' }}>
                {/* <Autocomplete
                options={siteAssessments}
                size="small"
                getOptionLabel={option => option?.title ?? ''}
                value={selectedSite || null}
                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                onChange={(event, newValue) => setSelectedSite(newValue)}
                renderInput={params => (
                  <TextField
                    label="Site Assessment"
                    {...params}
                    size="small"
                    sx={{
                      width: 300,
                      fontSize: '0.85rem',
                      '& .MuiOutlinedInput-input': {
                        fontSize: '0.85rem',
                        fontWeight: 'bold',
                        color: 'black',
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontWeight: 500,
                        color: '#000',
                        fontSize: '0.9rem',
                      },
                    }}
                  />
                )}
              /> */}

                {openNotificationType === 'site' && (
                  <Autocomplete
                    options={siteAssessments}
                    size="small"
                    getOptionLabel={option => option?.title ?? ''}
                    value={selectedSite || null}
                    isOptionEqualToValue={(option, value) => option?.id === value?.id}
                    onChange={(event, newValue) => setSelectedSite(newValue)}
                    renderInput={params => (
                      <TextField
                        label="Site Assessment"
                        {...params}
                        size="small"
                        sx={{
                          width: 300,
                          fontSize: '0.85rem',
                          '& .MuiOutlinedInput-input': {
                            fontSize: '0.85rem',
                            fontWeight: 'bold',
                            color: 'black',
                          },
                        }}
                        InputLabelProps={{
                          sx: {
                            fontWeight: 500,
                            color: '#000',
                            fontSize: '0.9rem',
                          },
                        }}
                      />
                    )}
                  />
                )}

                {/* {openNotificationType === 'contract' && (
                <Autocomplete
                  options={whNumberList}
                  getOptionLabel={option => option} // ✅ just use the string itself
                  value={selectedWH || null}
                  isOptionEqualToValue={(option, value) => option === value}
                  onChange={(event, newValue) => setSelectedWH(newValue)}
                  renderInput={params => (
                    <TextField
                      label="WH Number"
                      {...params}
                      size="small"
                      sx={{
                        width: 300,
                        fontSize: '0.85rem',
                        '& .MuiOutlinedInput-input': {
                          fontSize: '0.85rem',
                          fontWeight: 'bold',
                          color: 'black',
                        },
                      }}
                      InputLabelProps={{
                        sx: {
                          fontWeight: 500,
                          color: '#000',
                          fontSize: '0.9rem',
                        },
                      }}
                    />
                  )}
                />
              )} */}

                <TextField
                  label="Add Short Message"
                  value={shortMessage}
                  onChange={e => setShortMessage(e.target.value)}
                  size="small"
                  sx={{
                    width: 500,
                    '& .MuiOutlinedInput-input': {
                      fontSize: '0.85rem',
                    },
                    '& .MuiInputLabel-root': {
                      fontSize: '0.85rem',
                      fontWeight: 500,
                      color: '#000',
                    },
                  }}
                />

                <Button
                  variant="contained"
                  size="small"
                  onClick={handleAddMessage}
                  sx={{ height: 35, fontSize: '0.75rem', whiteSpace: 'nowrap' }}>
                  Add Message
                </Button>
              </Box>

              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: '0.75rem',
                  justifyContent: 'start',
                  alignItems: 'start',
                }}>
                {/* Email Notification */}
                <Card sx={{ flex: 1, p: 1, height: '22rem' }}>
                  <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1 }}>
                    Email Notification
                  </Typography>
                  {(selectedSite || selectedWH) && (
                    <>
                      <CustomInputField value={emailInput} onChange={handleEmailInput} onAdd={addEmail} error={emailError} />
                      {emailList.map(email => (
                        <Box key={email} sx={{ display: 'flex', alignItems: 'center', mt: '0.20rem' }}>
                          <FormControlLabel
                            sx={{
                              p: 0,
                              m: 0,
                              '& .MuiButtonBase-root': {
                                padding: '0rem 0.5rem 0.5rem 0.5rem',
                              },
                            }}
                            control={
                              <Checkbox checked={checkedEmails.includes(email)} onChange={() => handleEmailCheck(email)} />
                            }
                            label={email}
                          />
                        </Box>
                      ))}
                    </>
                  )}
                </Card>

                {/* SMS Notification */}
                <Card sx={{ flex: 1, p: 1, height: '22rem' }}>
                  <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1 }}>
                    SMS Notification
                  </Typography>
                  {(selectedSite || selectedWH) && (
                    <>
                      <CustomInputField value={smsInput} onChange={handleSMSInput} onAdd={addSMS} error={smsError} />
                      {smsList.map(num => (
                        <Box key={num} sx={{ display: 'flex', alignItems: 'center', mt: '0.20rem' }}>
                          <FormControlLabel
                            sx={{
                              p: 0,
                              m: 0,
                              '& .MuiButtonBase-root': {
                                padding: '0rem 0.5rem 0.5rem 0.5rem',
                              },
                            }}
                            control={<Checkbox checked={checkedSMS.includes(num)} onChange={() => handleSMSCheck(num)} />}
                            label={num}
                          />
                        </Box>
                      ))}
                    </>
                  )}
                </Card>

                {/* In App Notification */}
                <Card sx={{ flex: 1, p: 1, height: '22rem' }}>
                  <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1 }}>
                    In App Notification
                  </Typography>
                  {(selectedSite || selectedWH) && (
                    <>
                      <CustomSearchInputField
                        value={inAppInput}
                        onChange={handleInAppInput}
                        onAdd={addInAppUser}
                        options={allUsers.map(user => user.email || '')}
                      />
                      {inAppUsers.map(user => (
                        <Box key={user} sx={{ display: 'flex', alignItems: 'center', mt: '0.20rem' }}>
                          <FormControlLabel
                            sx={{ p: 0, m: 0, '& .MuiButtonBase-root': { padding: '0rem 0.5rem 0.5rem 0.5rem' } }}
                            control={
                              <Checkbox checked={checkedInAppUsers.includes(user)} onChange={() => handleInAppCheck(user)} />
                            }
                            label={user}
                          />
                        </Box>
                      ))}
                    </>
                  )}
                </Card>

                {/* Webapp Notification */}
                <Card sx={{ flex: 1, p: 1, height: '22rem' }}>
                  <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1 }}>
                    Webapp Notification
                  </Typography>
                  {(selectedSite || selectedWH) && (
                    <>
                      <CustomSearchInputField
                        value={webAppInput}
                        onChange={handleWebappInput}
                        onAdd={addWebAppUser}
                        options={allUsers.map(user => user.email || '')}
                      />
                      {webAppUsers.map(user => (
                        <Box key={user} sx={{ display: 'flex', alignItems: 'center', mt: '0.20rem' }}>
                          <FormControlLabel
                            sx={{ p: 0, m: 0, '& .MuiButtonBase-root': { padding: '0rem 0.5rem 0.5rem 0.5rem' } }}
                            control={
                              <Checkbox
                                checked={checkedWebAppUsers.includes(user)}
                                onChange={() => handleWebAppCheck(user)}
                              />
                            }
                            label={user}
                          />
                        </Box>
                      ))}
                    </>
                  )}
                </Card>
              </Box>
            </Box>
          </DialogContent>

          <DialogActions sx={{ borderTop: '1px solid #e0e0e0', mt: 'auto' }}>
            <Button onClick={handleClose}>Cancel</Button>
            <Button
              variant="contained"
              color="primary"
              disabled={checkedEmails.length === 0}
              onClick={handleNotificationSubmitButton}>
              Send Notification
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </div>
  );
};

export default NotificationPage;
